<template>
<div id="my-dialog">
  <!--无边框弹窗-->
  <div class="transparent-dialog-box" ref="transparentDialogBox">
     <slot>
      <span class="title"></span>
     </slot>
  </div>
</div>
</template>

<script>
export default {
  name: 'myDialog',
  components: {},
  props: {
    type: {
      type: String,
      default: 'normal',
    },
    show:{
      type:Boolean,
      default:false
    }
  },
  data() {
    return {
      transparent: false,
      normal: false,
      drag: false,
      tip: false,
      button: false,
    }
  },
  created() {

  },
  mounted() {
    this.init();
    if(this.$props.show) {
      this.createShadowDecoration(this.$refs.transparentDialogBox);
    }
  },
  methods: {
    //init
    init() {
      let currenDialogType = this.$props.type;
      switch (currenDialogType) {
        case "transparent":
          this.transparent = true;
          this.normal = false;
          this.drag = false;
          this.tip = false;
          this.button = false;
          break;
        case "normal":
          this.normal = true;
          this.transparent = false;
          this.drag = false;
          this.tip = false;
          this.button = false;
          break;
        case "drag":
          this.drag = true;
          this.transparent = false;
          this.normal = false;
          this.tip = false;
          this.button = false;
          break;
        case "tip":
          this.tip = true;
          this.transparent = false;
          this.normal = false;
          this.drag = false;
          this.button = false;
          break;
        case "button":
          this.button = true;
          this.transparent = false;
          this.normal = false;
          this.drag = false;
          this.tip = false;
          break;
      }
    },
    createShadowDecoration(element) {
      let box = document.createElement('div');
      box.id = 'transparetn-dialog-box';
      box.style.width = '100vw';
      box.style.height = '100vh';
      box.style.backgroundColor = 'rgba(0,0,0,.3)';
      box.style.position = 'absolute';
      box.style.zIndex = '99999999999';
      box.style.top = 0;
      box.style.left = 0;
      box.style.display = 'flex';
      box.style.flexDirection = 'column';
      box.style.alignItems = 'center';
      box.style.justifyContent = 'center';
      document.body.appendChild(box);
      box.append(element);
      return box;
    }
  }
}
</script>

<style scoped src='../../assets/css/components/dialog/MyDialog.css'></style>
